<template>
  <component :is="layout">
    <login-dialog-container
      @changeCurrent="onChangeCurrent"
    />
  </component>
</template>
<script>
export default {
    name: 'Explore',
    data() {
        return {
            currentDialog: '',
        };
    },
    computed: {
        layout() {
            if (this.currentDialog === 'ShowVideo') {
                return 'FullLayout';
            }
            if (this.currentDialog === 'TellUsAboutYourself') {
                return 'AboutYourselfLayout';
            }

            if (this.currentDialog === 'VerifyStudentData') {
                return 'AboutYourselfLayout';
            }

            return 'HomeLayout';
        },
    },
    methods: {
        onChangeCurrent(evt) {
            this.currentDialog = evt;
        },
    },
};
</script>
<style lang="scss">
</style>
